import { useLocation, useParams } from 'react-router-dom';

// TODO: This was used when the map was the main part of the website. Now that more routes are introduced, this is no longer useful
export function useSection() {
  const location = useLocation();
  const params = useParams<{ workspace: string }>();
  const section = location.pathname
    .split('/')
    .filter(Boolean)
    .filter((part) => part !== params.workspace)
    .pop();

  return section;
}

export default useSection;
